var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0116 0.835938H1.71909C0.972457 0.835938 0.367188 1.44121 0.367188 2.18784V23.4804C0.367188 24.227 0.972457 24.8323 1.71909 24.8323H23.0116C23.7583 24.8323 24.3635 24.227 24.3635 23.4804V2.18784C24.3635 1.44121 23.7583 0.835938 23.0116 0.835938Z",
    stroke: "#D9D9D9",
    strokeWidth: 0.333282
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8672 19.5H3.86977C3.77773 19.5 3.70312 19.5746 3.70312 19.6666C3.70312 19.7587 3.77773 19.8333 3.86977 19.8333H20.8672C20.9592 19.8333 21.0338 19.7587 21.0338 19.6666C21.0338 19.5746 20.9592 19.5 20.8672 19.5Z",
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45310_201313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5894 10.9453L9.70095 13.8338L6.8125 10.9453",
    stroke: "#4D4D4D",
    strokeWidth: 0.833206,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80904 8.05469L9.69749 5.16624L12.5859 8.05469",
    stroke: "#4D4D4D",
    strokeWidth: 0.833206,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45310_201313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.665,
    height: 10.665,
    fill: "white",
    transform: "translate(4.36719 4.16797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdown-icon.245b38deff4910579739d72bc76ef68b.svg";
export { ForwardRef as ReactComponent };